export const fontList = [
  "Noto-Sans-Thai-Looped-Thin",
  "Noto-Sans-Thai-Looped-Light",
  "Noto-Sans-Thai-Looped-Regular",
  "zfull-GB",
  "Fangzheng-Cu",
  "Microsoft-YaHei-UI-Light",
  "WenQuanYi-Micro-Hei",
  "NotoSansArmenian-Bold",
  "NotoSansArmenian-Regular",
];

export const fontSizeList = [
  14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 60, 80, 100, 150,
];

export const fontWeightList = [600, 700, 800, 900];
